import React, {useCallback, useEffect, useState} from "react";
import { useLocation } from "react-router-dom";
import Map from './Map';
import Plot from './Plot';
import FloatingSidebar from './FloatingSidebar';
import axios from 'axios';   
import { getVar } from './Helper';
import Loading from './Loading';
import Toast from './Toast';  
import AdvancedFilters from './AdvancedFilters';
import styled from 'styled-components'

const Logo = styled.a`
        position: fixed;
        z-index: 401;
        bottom: 18px;
        right: 25px;
    `;

function Home() {
    let query = new URLSearchParams(useLocation().search);   

    const [plots,setPlots] = useState([]);   
    const [loading,setLoading] = useState(true);
    const [msg,setMsg] = useState(false);  
    const [activeMarkets, setActiveMarkets] = useState([]);   
    const [leftSidebar, setLeftSidebar] = useState(false); 
    const [catIds, setCatIds] = useState([]); 
    
    useEffect(()=>{     
        fetchResults(getVar().apiUrl+'get-plots/');
    },[])   

    const filterMarkets = useCallback((key)=>{        
        setLoading(true);                 
        let mkts = activeMarkets; 
        if(!mkts.includes(key)){
            mkts.push(key);            
        }else{
            mkts.splice(mkts.indexOf(key),1);
        }   
        setActiveMarkets(mkts);
        let url =  getVar().apiUrl; 
        url += mkts.length > 0 ? 'get-plots/?parent-cats='+mkts.join(',') : 'get-plots/';
        fetchResults(url); 
    },[activeMarkets]);

    const searchPlots = useCallback((evt)=>{ 
        if(evt.key === 'Enter' && evt.target.value){ 
            setLoading(true);
            fetchResults(getVar().apiUrl+'get-plots/?term='+evt.target.value); 
        }else if(evt.key === 'Enter' && evt.target.value === ''){
            setLoading(true);
            fetchResults(getVar().apiUrl+'get-plots/');
        }
    },[]);


    const filterAdvancedHanlder = useCallback((catId)=>{       
        let cats = catIds;
        if(cats.includes(catId)){
            cats.splice(cats.indexOf(catId),1);
        }else{
            cats.push(catId);
        }               
        setCatIds(cats);
        
        if(cats.length === 0){
            fetchResults(getVar().apiUrl+'get-plots/');
        }else{
            fetchResults(getVar().apiUrl+'get-plots/?cat-ids='+cats.join(','));
        }
        // setLeftSidebar(false);
    },[catIds])

    
    const fetchResults = (url) => {
        axios.get(url).then(response => { 
            if(response.data.length === 0){
                setMsg('No results found.');
            }else{
                setMsg(false);
            }
            setPlots(response.data); 
            setLoading(false);  
        }) 
    }

    return (
        <>
        <Toast msg={msg} />
        <Loading show={loading} />
        <div className="main-wrapper">  
            {leftSidebar ? (<AdvancedFilters 
                setLoading={setLoading}
                catIds={catIds}
                filterAdvancedHanlder={filterAdvancedHanlder}
                setLeftSidebar={setLeftSidebar}/>) : null}            
            <Logo href="http://www.parsons.com" target="_blank">
                <img src={getVar().logoUrl} alt="Parsons logo"/>
            </Logo>      
            {(() => {
                let plotid = query.get('plot');
                if(plotid){
                    return (
                        <Plot id={plotid} />
                    )
                }              
            })()}      
            <FloatingSidebar 
                setLeftSidebar={setLeftSidebar}
                activeMarkets={activeMarkets}               
                filterMarkets={filterMarkets} 
                searchPlots={searchPlots} />
            <Map plots={plots} />
        </div>
        </>
    )
}

export default Home;
